// Rotas de DADOS SENSÍVEIS: acesso só com concessão EXPLÍCITA.
//
// Espelha api/src/constants/restrictedRoutes.ts — os dois lados precisam
// concordar. O backend é quem realmente enforça (requireRouteAccess e o nível
// no /me); esta lista existe para o menu e o guard não prometerem um acesso que
// a API vai negar, e para o admin master não ver o item sem ter permissão.
//
// Nas rotas abaixo, o bypass de admin master do menu/guard NÃO se aplica: quem
// entra é quem tem concessão em /permissions (user_route_level) ou grupo
// vinculado à rota. O admin master segue administrando as permissões — só não vê
// os dados sem se conceder acesso.

/** Rotas Vue cujo acesso exige concessão explícita (sem bypass de admin master). */
export const RESTRICTED_ROUTE_PATHS: ReadonlySet<string> = new Set([
  // Contas CC — contas a pagar e compras por centro de custo (financeiro sensível)
  '/financeiro/centro-de-custo',
  // Master Loja — alteração do preço que o cliente paga. Não existe TELA neste
  // caminho (a edição vive na aba Variantes do produto): a rota é só o gate da
  // concessão individual, e é `useUserPermissions` quem a consulta.
  '/ecommerce/master-loja/precos',
    // Documentos Fiscais (TSS) — ver o comentário em api/src/constants/restrictedRoutes.ts.
    '/financeiro/relatorios/fiscal-tss',
    '/financeiro/relatorios/fiscal-tss/via',
    '/financeiro/relatorios/fiscal-tss/sim',
    // Dashboards › P&D tecnológico — ver o comentário em api/src/constants/restrictedRoutes.ts.
    '/dashboards/pd-tecnologico',
]);

/** A rota exige concessão explícita? Considera subpaths (ex.: .../detalhe). */
export function isRestrictedRoute(routePath: string | null | undefined): boolean {
  const path = (routePath ?? '').trim();
  if (!path) return false;
  if (RESTRICTED_ROUTE_PATHS.has(path)) return true;
  for (const base of RESTRICTED_ROUTE_PATHS) {
    if (path.startsWith(`${base}/`)) return true;
  }
  return false;
}
